import { makeStyles } from '@material-ui/core/styles'
import { coachProfileBandSectionGap } from '@lib/pga-coach/coach-profile-layout'

const useStyles = makeStyles((theme) => ({
  root: ({ inColumn }) => ({
    // White belongs to the flagged profile column only. CoachArticlesQuery
    // also mounts on CoachesProfileLayoutLegacy when the UX flag is off.
    // Container maxWidth={false} / disableGutters are gated the same way
    // so the production slider keeps gutters when the flag is off.
    backgroundColor: inColumn
      ? theme.palette.common.white
      : theme.palette.grey[100],
    color: theme.palette.text.primary,
  }),
  paginationDash: {
    padding: `0 ${theme.spacing(1)}px`,
    fontSize: '1.25rem',
    lineHeight: 1,
    color: theme.overrides.MuiBreadcrumbs.separator.color,
  },
  paginationNumber: {
    fontSize: '0.875rem',
    letterSpacing: '0.1em',
    fontWeight: '600',
    color: theme.overrides.MuiBreadcrumbs.separator.color,
  },
  articlesWrapper: ({ inColumn }) => ({
    /**
     * Photos paddingBottom is 0, so the next in-column band owns the
     * 48px gap. When articles render that band is this wrapper —
     * `coachProfileBandSectionGap` paddingTop, paddingBottom 0 so
     * Testimonials do not stack to 96px. Legacy (flag off) keeps
     * the previous bottom padding and does not take the band gap.
     */
    ...(inColumn
      ? {
        ...coachProfileBandSectionGap(theme),
        paddingBottom: 0,
      }
      : {
        paddingBottom: theme.spacing(6),
      }),
    paddingLeft: inColumn ? 0 : theme.spacing(4),
    paddingRight: inColumn ? 0 : undefined,
    color: theme.palette.text.primary,
    '& h4': {
      textAlign: 'center',
      margin: theme.spacing(2),
      ...(inColumn ? { marginTop: 0 } : null),
    },

    '& .slick-slider': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginBottom: '-2rem',

      '& .slick-arrow': {
        position: 'relative',
        left: 'unset',
        right: 'unset',
        transform: 'unset',
        margin: '10px 48px',
        zIndex: 2,

        '&:before': {
          fontFamily: 'unset',
          content: 'unset',
        },
      },

      '& .slick-list': {
        order: 1,
        width: '100%',
      },
      '& .slick-prev': {
        order: 2,
        transform: 'scaleX(-1)',
      },
      '& .slick-next': {
        order: 3,
      },
      '& .slick-dots': {
        bottom: '-10px',
        backgroundColor: 'white',
        borderRadius: '5px',
        padding: '10px',
      },
      '& .slick-slide': {
        '& a:first-child': {
          height: '400px',
          [theme.breakpoints.down('xs')]: {
            height: '450px',
          },
        },
      },
      '& .slick-active.slick-current': {
        paddingLeft: 0,
      },
    },
  }),
  itemWrapper: {
    width: '95% !important',
  },
}))

export default useStyles
